export default __webpack_public_path__ + "static/media/EntertainmentFeed.529190d4.jpeg";